import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                link: 'onLinkClick'
            }
        }

        this.$link = Array.from(this.$('link'))
    }

    setActiveById(id) {
        let current = this.$link.find(item => item.classList.contains('is-current'))
        current.classList.remove('is-current')
        let link = this.$link.find(item => item.hash == '#'+id)
        link.classList.add('is-current')
    }

    inviewSection(e) {
        if(e.way == 'enter') {
            this.setActiveById(e.obj.target.id)
        }
    }

    onLinkClick(e) {
        e.preventDefault();
        e.stopPropagation();

        const href = e.currentTarget.href;
        const anchor = href.substr(href.indexOf('#'));

        this.call('scrollTo', [anchor, { offset: -150 }], 'Scroll')
    }
}
